import { useCallback, useMemo } from "react";
import { getValidationError as ValidationError } from '../../Helper';
import { useDispatch } from "react-redux";
import { addPartiesTabWarnings, deletePartiesTabWarnings } from '../../../commonActions/serverErrorAction';
import { useDebounce } from "../../../hooks";
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType';

export default function ErrorWindowPartiesTab({ actorType, dataSource = {}, children, translate, ...rest }) {
  const dispatch = useDispatch()

  const { serviceType, customJobState } = useCurrentShipmentType()

  const pdiValidationCheck = customJobState?.includes("PDI");

  const getValidationError = (field, value, Level, onlyMandatoryCheck = false) => ValidationError(field, value, Level, onlyMandatoryCheck, serviceType, translate, pdiValidationCheck)

  const addErrors = useCallback((level, value, fieldName) => {
    dispatch(addPartiesTabWarnings(level, value, fieldName))
  }, [dispatch])

  const deleteErrors = useCallback((level, value, fieldName) => {
    dispatch(deletePartiesTabWarnings(level, value, fieldName))
  }, [dispatch])

  const AddRemoveErrorsFromWindow = useCallback((actorType, key, value) => {
    let err = getValidationError(convertToLowerCase(actorType) + key, value, "partiesTab", false, serviceType, translate)
    err.length
      ? addErrors('partiesTab', err[0], convertToLowerCase(actorType) + key)
      : deleteErrors('partiesTab', '', convertToLowerCase(actorType) + key)
  }, [])

  const debouncedDataSource = useDebounce(dataSource, 2000)

  const convertToLowerCase = (value) => value.toLowerCase()
  const errors = useMemo(() => {
    let errorInfo = {}
    const { id, actorType, actorTypeID, streetName, streetNumber, country, formOfRepresentation, addressId, ...rest } = debouncedDataSource
    if (!actorType)
      return []
    Object.entries(rest).forEach(([key, value]) => {
      AddRemoveErrorsFromWindow(actorType, key, value)
      errorInfo = {
        ...errorInfo,
        [key]: getValidationError(convertToLowerCase(actorType) + key, value, "partiesTab", false, serviceType, translate)
      }
    })
    return errorInfo
  }, [debouncedDataSource, translate])

  return children(errors)
}